module.exports = __webpack_public_path__ + "img/CS-Lite-Vol_Overview-Spare_4.87a189be.jpg";